import styled from 'styled-components';
import { Box } from '@mui/material';

export const PreselectFiltersModalContentStyled = styled(Box)(
  ({ theme: { palette, breakpoints } }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 520,
    maxHeight: '90vh',
    overflow: 'auto',
    background: palette.background.paper,
    border: `1px solid ${palette.divider}`,
    borderRadius: 6,
    padding: 32,
    [breakpoints.down('sm')]: { width: '90%', padding: 16 },
  }),
);

export const PreselectFiltersStyled = styled(Box)((_) => ({
  backgroundColor: 'transparent',
  '& .filters-button-container': {
    alignItems: 'flex-start',
    flexDirection: 'column',
    width: '100%',
    '& .MuiButton-contained': {
      width: '100%',
      maxWidth: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '8px',
      marginRight: 0,
    },
  },
}));
